/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

export default {
  storePaypalClientId(state, payload) {
    state.paypalClientId = payload.value;
  },
  storePaypalThresholdForBundle(state, payload) {
    state.paypalThresholdForBundle = payload.value;
  },
  emailVerification(state, payload) {
    state.verification = payload.payload;
  },
  clearEmailVerification(state) {
    state.verification = {};
  },
  setFallingItemsAddOnGameCss(state, payload) {
    state.fallingItemsAddOnGameCss = payload.value;
  },
  setActiveAddOnMiniGame(state, payload) {
    state.activeAddOnMiniGame = payload;
  },
  setTimerForLanternGame(state, payload) {
    state.timerForLanternGame = payload.value;
  },
  setTimerForPuzzleGame(state, payload) {
    state.timerForPuzzleGame = payload.value;
  },
  updateFreeTrialPoints(state, payload) {
    state.freeTrialPoints = payload.value;
  },
  setPostGameSettings(state, payload) {
    state.postGameSettings = payload.value;
  },
  updatePhoneShortcut(state, payload) {
    state.phoneShortcutEnabled = payload.value;
  },
  updateCrossPromotion(state, payload) {
    state.showCrossPromotionPhase = payload.value;
  },
  updateOptOutFromHome(state, payload) {
    state.showOptOutPhase = payload.value;
  },
  updateServicePromotion(state, payload) {
    state.servicePromotionModal = payload.value;
  },
  storePushNotificationsPublicKey(state, payload) {
    state.pushNotificationsPublicKey = payload.value;
  },
  storeInviteReferral(state, payload) {
    state.inviteReferral = payload.inviteReferral;
  },
  toggleProfile(state) {
    state.userDetails = {
      ...state.userDetails,
      hasPrivateProfile: !state.userDetails.hasPrivateProfile,
    };
  },
  setShareAchievementPoints(state, points) {
    state.shareAchievementPoints = points.value;
  },
  setTotalAchievements(state, payload) {
    state.userDetails = {
      ...state.userDetails,
      achievements: payload.value,
    };
  },
  setInviteConfig(state, payload) {
    state.inviteConfig = payload.value;
  },
  updateMessagingConfig(state, payload) {
    state.messaging = payload.value;
  },
  toggleNeedLoad(state, payload) {
    state.needLoad = payload.value;
  },
  registerModal(state, payload) {
    state.activeModals.push(payload.value);
  },
  emptyActiveModalsStack(state) {
    state.activeModals = [];
  },
  unregisterModal(state) {
    state.activeModals.pop();
  },
  storeModalForChallenge(state, modal) {
    state.modalForChallenge = modal;
  },
  storeHomeScreenModalDisable(state, payload) {
    state.homeScreenModalDisable = payload;
  },
  storeModalForHomePage(state, modal) {
    if (modal && modal.name === 'resubscribe-game' && state.userDetails.gamesPlayed < state.minGamesToPlay) return;
    state.modalForHomePage = modal;
  },
  storeModalForStore(state, modal) {
    if (modal && modal.name === 'resubscribe-game' && state.userDetails.gamesPlayed < state.minGamesToPlay) return;
    state.modalForStore = modal;
  },
  updateTimeToAcceptChallenge(state, payload) {
    state.timeToAcceptChallenge = payload.value;
  },
  updateUsername(state, value) {
    state.userDetails.username = value;
  },
  updateEmailVerified(state, value) {
    state.userDetails.hasEmailVerified = value;
  },
  updateFreeTrialRedirectionUrl(state, payload) {
    state.freeTrialRedirectionUrl = payload.value;
  },
  setShowMaskProfileEdit(state, payload) {
    state.showMaskProfileEdit = payload.value;
  },
  updateProducedUniqueId(state, payload) {
    state.producedUniqueId = payload.value;
  },
  updateConversionForArabicFields(state, payload) {
    state.conversionForArabicFields = payload.value;
  },
  updateChatStatus(state, payload) {
    state.chatEnabled = payload.value;
  },
  setMinGamesToPlay(state, payload) {
    state.minGamesToPlay = payload.value;
  },
  updateCPC(state, payload) {
    state.cpc = payload.cpc;
  },
  setShowMsisdnInProfilePage(state, payload) {
    state.showMsisdnInProfilePage = payload.value;
  },
  setCorrelationId(state, payload) {
    state.correlationId = payload.value;
  },
  setHideChangePassword(state, payload) {
    state.hideChangePassword = payload.value;
  },
  setHideLangSelection(state, payload) {
    state.hideLangSelection = payload.value;
  },
  setReoptinOptoutConfig(state, payload) {
    state.reoptinAndOptoutConfig = payload.value;
  },
  setTimeWinnerIndication(state, payload) {
    state.timeWinnerIndication = payload.value;
  },
  setShowSelectOperatorModal(state, payload) {
    state.showSelectOperatorModal = payload.value;
  },
  setShowNoBalanceModal(state, payload) {
    state.showNoBalanceModal = payload.value;
  },
  setIntegrationInfo(state, payload) {
    state.integrationConfig.config.parameters = payload.value.data;
  },
  setHideLeaderboard(state, payload) {
    state.hideLeaderboard = payload.value;
  },
  setAddOnMode(state, payload) {
    state.addOnMode = Object.values(state.addOnModesEnum).filter(mode => mode.text === payload.value)[0];
  },
  setPurchaseBundleFromUnsubUser(state, payload) {
    state.purchaseBundleFromUnsubUser = payload.value;
  },
  setIntegrationConfig(state, payload) {
    const { integrationKey, config } = payload.value;
    state.integrationConfig = { integrationKey, config: config && JSON.parse(config) };

    state.integrationConfig = {
      ...state.integrationConfig,
      config: config && {
        ...state.integrationConfig.config,
        parameters: state.integrationConfig.config.parameters.split(",").map(param => ({ key: param, value: '' })),
      },
    };
  },
  setMergedParam(state, payload) {
    state.mergedParam = payload.value;
  },
  storeHidePrizePage(state, payload) {
    state.hidePrizePage = payload.value;
  },
  storePurchaseViaSMS(state, payload) {
    state.purchaseViaSMS = payload.value;
  },
  setFbAppId(state, payload) {
    document.getElementById('fb:app_id').content = payload.value;
    state.fbAppId = payload.value;
  },
  setVersionInfo(state, payload) {
    state.versionInfo = payload.value;
  },
  storeWinnersShowMsisdn(state, payload) {
    state.winnersShowMsisdn = payload.value;
  },
  storeDuelSkin(state, payload) {
    state.duelSkin = localStorage.getItem('duelSkin') || payload.value;
  },
  storePuzzleGameCss(state, payload) {
    state.puzzleGameCss = payload.value;
  },
  storeTimeRounds(state, payload) {
    state.roundTimeList = payload.value;
  },
  updateMultiOperatorOrdinal(state, payload) {
    state.multiOperatorInfo.multiOperatorOrdinal = payload.value;
  },
  setMultiOperatorDisplayNames(state, payload) {
    state.multiOperatorInfo.multiOperatorDisplayNames = payload.value;
  },
  setOperator(state, payload) {
    state.multiOperatorInfo.operatorPicked = payload.value;
  },
  setMultiOperator(state, payload) {
    state.multiOperatorInfo.multiOperatorEnabled = payload.value;
  },
  setMultiOperatorKeys(state, payload) {
    state.multiOperatorInfo.multiOperatorKeys = payload.value;
  },
  setMultiOperatorDisplayedNamesInRegisterPage(state, payload) {
    state.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage = payload.value;
  },
  setHideWinners(state, payload) {
    state.hideWinners = payload.value;
  },
  storeBanner(state, payload) {
    state.banner = payload.value;
  },
  setHideStore(state, payload) {
    state.hideStore = payload.value;
  },
  setSmsAutomaticResponse(state, payload) {
    state.smsAutomaticResponse = payload.value;
  },
  setDisplayPrice(state, payload) {
    state.displayPrice = payload.value;
  },
  storeFacebookFunctionality(state, payload) {
    state.facebookFunctionality = payload.value;
  },
  setLastRandomRound(state, payload) {
    state.lastRandomRound = payload.value;
  },
  storeUserAvatar(state, avatar) {
    state.userAvatar = avatar;
  },
  setDisplayAvatar(state, payload) {
    state.userDetails.displayAvatar = payload.item;
    if (state.userDetails.displayAvatar === true) {
      state.userAvatar = state.userDetails.avatar;
    } else {
      state.userAvatar = state.userDetails.facebookImage;
    }
  },
  storeUserDetailsFromDuel: (state, payload) => {
    // Everything that is used from duel db
    const {
      availableGames,
      id,
      msisdn,
      avatarGender,
      displayAvatar,
      facebookImage,
      facebookId,
      avatar,
      hasPrivateProfile,
      hasPhoneShortcut,
      hasEmailVerified,
    } = payload;

    state.userDetails = {
      ...state.userDetails,
      level: payload.userLevel,
      username: payload.userId,
      userAvatar: state.userDetails.displayAvatar ? payload.avatar : payload.facebookImage,
      hasPassword: payload.password === 'true',
      id,
      msisdn,
      avatar,
      avatarGender,
      displayAvatar,
      facebookId,
      facebookImage,
      availableGames,
      hasPrivateProfile,
      hasPhoneShortcut,
      hasEmailVerified,
    };
  },
  updateDisplayAvatar(state, avatar) {
    state.userDetails.displayAvatar = avatar;
  },
  facebookReferral(state, payload) {
    state.fbReferral = payload.fbRef;
  },
  updateSimpleRegistration(state, payload) {
    state.simpleRegistration = payload.value;
  },
  updateTwoStepRegistration(state, payload) {
    state.twoStepRegistration = payload.value;
  },
  storeConnectionPoints(state, payload) {
    state.connectionPoints = payload.value;
  },
  updateReoptinOnestep(state, payload) {
    state.reoptinOnestep = payload.value;
  },
  storeFacebookImage(state, facebookImage) {
    state.userDetails.facebookImage = facebookImage;
  },
  deletePreviousFacebookImage(state) {
    state.userDetails.facebookImage = '';
  },
  updateRefUrl(state, payload) {
    state.refUrl = payload.refUrl;
  },
  updateCampaignId(state, payload) {
    state.campaignId = payload.campaignId;
  },
  updatePublisherId(state, payload) {
    state.publisherId = payload.publisherId;
  },
  storeClickid(state, payload) {
    state.clickid = payload.clickid;
  },
  updateSplashUrl(state, payload) {
    state.splashUrl = payload.value;
  },
  updateSplashTimer(state, payload) {
    state.splashTimer = payload.value;
  },
  setProfilePath(state, boolean) {
    state.profilePath = boolean;
  },
  setNewAvatarGender(state, avatarGender) {
    state.userDetails.avatarGender = avatarGender;
  },
  storeAvatar(state, avatar) {
    state.userDetails.avatar = avatar;
  },
  deletePreviousAvatar(state) {
    state.userDetails.avatar = '';
  },
  storeModalForSettings(state, modal) {
    state.modalForSettings = modal;
  },
  updateAvatarGrouping(state, payload) {
    state.avatarGrouping = payload.value;
    state.isAvatarGroupWithoutAccessories = (state.avatarGrouping === 7 || state.avatarGrouping === 10);
  },
  updatePinForBundles(state, payload) {
    state.pinForBundles = payload.value;
  },
  updateSubAndUnsubViaSMS(state, payload) {
    state.subAndUnsubViaSMS = payload.value;
  },
  updateEnablePopUpForCrossPromotion(state, payload) {
    state.enablePopUpForCrossPromotion = payload.value;
  },
  updateFreeTrialStripe(state, payload) {
    state.freeTrialStripe = payload.value;
  },
  updateLogoOnFooter(state, payload) {
    state.logoOnFooter = payload.value;
  },
  updateTrackingId(state, payload) {
    state.trackingId = payload.value;
  },
  updateVatBanner(state, payload) {
    state.vatBanner = payload.value;
  },
  updateFacebookPixelId(state, payload) {
    state.facebookPixelId = payload.value;
  },
  storeParameters(state, payload) {
    state.clickid = payload.parametersAdAgency.clickid;
  },
  setUserLanguage(state, payload) {
    state.userDetails.language = payload.userLanguage;
  },
  setSoundsOnOrOff(state, soundsOn) {
    state.soundsOn = soundsOn;
    console.log(`setting sounds status in vuex to: ${state.soundsOn}`);
  },
  updateSoundsStatusFromLocaleStorage(state) {
    state.soundsOn = localStorage.getItem('soundsOn') === "true";
    console.log(`reading sounds status from locale storage: ${state.soundsOn}`);
  },
  storeUserDetails(state, userDetails) {
    Object.assign(state.userDetails, userDetails);
  },
  storeUserMSISDN(state, payload) {
    state.userDetails.msisdn = payload.msisdn;
  },
  setUserSubscribed(state, payload) {
    state.userDetails.subscribed = payload.subscribed;
  },
  storeUserAvailableGames(state, payload) {
    state.userDetails.availableGames = payload.availableGames;
  },
  // storeUserJokersCheat(state, payload) {
  //   state.userDetails.jokersCheat = payload;
  // },
  // storeUserJokersFifty(state, payload) {
  //   state.userDetails.jokersFifty = payload;
  // },
  storeUserLevel(state, level) {
    state.userDetails.level = level;
  },
  setInstallPromptEvent(state, event) {
    state.installPromptEvent = event;
  },
  clearInstallPromptEvent(state) {
    state.installPromptEvent = null;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/common/mutations.js